import Icon from 'veui/components/Icon'
import { IconLongVideo } from 'dls-icons-vue'

Icon.register('long-video', IconLongVideo)
